import { theme, Drawer, type DrawerProps } from 'antd'
import { useEbolMatchingContext } from '../../EbolMatchingContext'

export type EbolDrawerBaseProps = Omit<DrawerProps, 'className' | 'open' | 'onClose'>

export const EbolDrawerBase = ({ title, classNames, styles, ...rest }: EbolDrawerBaseProps) => {
  const { isOpen, close } = useEbolMatchingContext()
  const {
    token: { colorBorder },
  } = theme.useToken()
  return (
    <Drawer
      width='63rem'
      closable
      placement='right'
      getContainer={false}
      destroyOnClose
      {...rest}
      open={isOpen}
      onClose={close}
      title={title}
      classNames={{
        ...classNames,
        body: 'drawer-body ' + (classNames?.body ?? ''),
        header: 'section ' + (classNames?.header ?? ''),
        footer: 'section footer ' + (classNames?.footer ?? ''),
      }}
      styles={{
        ...styles,
        content: {
          borderLeft: `1px solid ${colorBorder}`,
          borderRadius: '0.25rem',
          ...styles?.content,
        },
      }}
      className='ebol-matching-drawer'
    />
  )
}
